<i18n>{
  "fr": {
    "privacy": "Vie privée & données personnelles",
    "title": "Données personnelles",
    "foreword": {
      "title": "Avant-propos",
      "text": {
        "1": "Cette rubrique contient la Politique de confidentialité et de protection de la vie privée. Elle a pour but de vous renseigner sur vos droits concernant les informations collectées et traitées par Amplitudes lors de votre visite sur le site ou de l’utilisation des services, et d’en préciser l’origine et l’usage. Vous y trouverez des renseignements complets et précis au sujet de votre consultation sur le site et l’utilisation des services.",
        "2": "En utilisant le site d’Amplitudes, vous déclarez accepter les termes de la présente Politique de confidentialité et de protection de la vie privée.",
        "3": "Toute personne qui n’est pas d’accord avec l’un des termes de la présente politique est libre de ne plus utiliser le site d’Amplitudes et/ou de faire appel à nos services.",
        "4": "Amplitudes se réserve le droit de modifier à tout moment et sans préavis la présente Politique de confidentialité et protection de la vie privée.",
        "5": "Toute modification prendra effet immédiatement et ne concernera pas les utilisations du site antérieures à ladite modification. Il est donc recommandé que lors de chaque visite, l’utilisateur s’assure des dispositions en vigueur en consultant la Politique de confidentialité et protection de la vie privée."
      }
    },
    "article": {
      "1": {
        "title": "1. Informations générales",
        "text": {
          "1": "informations générales"
        }
      }
    }
  },
  "en": {
    "privacy": "Privacy & personal data"
  }
}
</i18n>

<template>
  <div>
    <v-card
      class="mx-auto my-8"
      max-width="70%"
    >
      <v-card-text>
        <div>
          <h1>{{ $t('title') }}</h1>

          <div id="foreword">
            <h2>{{ $t('foreword.title') }}</h2>
            <p>{{ $t('foreword.text.1') }}</p>
            <p>{{ $t('foreword.text.2') }}</p>
            <p>{{ $t('foreword.text.3') }}</p>
            <p>{{ $t('foreword.text.4') }}</p>
            <p>{{ $t('foreword.text.5') }}</p>
          </div>

          <div>
            <h2>{{ $t('article.1.title') }}</h2>
            <p>{{ $t('article.1.text.1') }}</p>
          </div>

          <div>
            <h2>2. collecte, utilisation et conservation des données</h2>
            <h3><strong>2.1 Collecte de données:</strong></h3>
            <h4><strong>Données personnelles</strong></h4>
            <p>Amplitudes a la possibilité de collecter les données personnelles de l’utilisateur:</p>
            <ul>
              <li>s’il complète la rubrique Contact,</li>
              <li>s’il s’abonne à la Newsletter électronique proposée par Amplitudes,</li>
              <li>s’il dépose sa candidature pour un emploi chez Amplitudes,</li>
              <li>s’il demande et/ou autorise la création d’un compte client à son nom,</li>
              <li>s’il y a eu un contact téléphonique avec l’un de nos agents de voyage,</li>
              <li>
                s’il y a eu une entrevue avec l’un de nos agents lors d’une visite dans l’une des agences
                Amplitudes.
              </li>
            </ul>
            <p>
              Par «données personnelles»<em />nous entendons toute
              information fournie de plein gré par l’utilisateur à Amplitudes et le concernant en tant que personne.
              Elles peuvent être renseignées lors de la visite de l’utilisateur sur le site, notamment par
              l’intermédiaire du formulaire figurant sur le site ou du questionnaire visant à définir le souhait de
              voyage de l’utilisateur, qui peut être fait par téléphone ou en agence.
            </p>
            <p>
              Les données personnelles comprennent des données nominatives que l’utilisateur renseigne sur le site
              (nom, coordonnées, et autres) et des données d’identification électronique qui sont accessibles sur ou
              à partir de votre ordinateur, telles que les cookies ou les adresses IP. Avec les données
              d’identification, il est possible d’identifier le terminal de connexion, de le géocaliser à l’échelle
              d’une ville, et de connaître les pages consultées sur le site d’Amplitudes. Mais ces informations sont
              généralement insuffisantes pour vous identifier de façon nominative
            </p>
            <h4><strong><br></strong></h4>

            <h4><strong>Les cookies Flash© de Adobe Flash Player™</strong></h4>
            <p>
              Cet article a pour but d’informer l’utilisateur sur le mode de fonctionnement de notre site et
              l’usage des cookies conformément aux recommandations de la CNIL.
            </p>
            <p>
              Un cookie est un fichier qui est déposé par le navigateur sur l’ordinateur ou tout autre terminal
              pouvant se connecter à internet (tablette, téléphone portable ou autres). Il n’est pas possible
              d’identifier précisément un utilisateur grâce aux cookies, mais seulement de reconnaître son terminal,
              afin par exemple de sauvegarder ses préférences et ses réglages. C’est un moyen pour Amplitudes
              d’améliorer la navigation et de rendre la consultation du site plus pratique et fonctionnelle.
            </p>
            <p>
              Nous précisons toutefois que les cookies enregistrés à travers les sites internet d’Amplitudes ne
              conservent en aucun cas les données personnelles ou sensibles de l’utilisateur.
            </p>
            <h4><strong><br></strong></h4>

            <h4><strong>Réseaux sociaux</strong></h4>
            <p>
              Amplitudes participe aux médias sociaux, et il est notamment l’éditeur d’une page d’information et de
              présentation de l’entreprise sur Facebook™, Twitter™, Instagram, Linkedin™, ou encore Viadeo™.
            </p>
            <p>
              Nous rappelons ici que toute information personnelle qui est indiquée comme étant publique est
              accessible par tous depuis le profil de l’utilisateur, et que par conséquent Amplitudes peut y
              accéder. Amplitudes ne peut en aucun cas créer ou utiliser une base de données indépendantes à partir
              des informations personnelles que vous publiez. Si vous ne souhaitez pas qu’Amplitudes ait accès à des
              informations personnelles que vous avez publié, il est possible de contrôler l’accès à votre profil en
              réglant les paramètres.
            </p>
            <p>
              Par ailleurs, il est conseillé de prendre connaissance de la politique de données personnelles des
              réseaux sociaux que vous utilisez.
            </p>
            <h4><strong><br></strong></h4>

            <h4><strong>Amplitudes Carrières</strong></h4>
            <p>
              Pour postuler auprès d’Amplitudes, le candidat doit compléter un dossier dans la rubrique prévue à
              cet effet. Amplitudes collectera ensuite les données personnelles renseignées par le candidat afin de
              pouvoir étudier sa candidature et y répondre.
            </p>
            <p>
              Lors de l’envoi de sa candidature, l’utilisateur reconnait et accepte qu’Amplitudes et ses filiales
              situées dans l’Espace économique européen soient destinataires des données personnelles fournies, et
              que celles-ci pourront être transmises à des cabinets de recrutement en fonction du poste à
              pourvoir.
            </p>
            <h4><strong><br></strong></h4>

            <h4><strong>Paiement en ligne sécurisé</strong></h4>
            <p>
              Lorsqu’un utilisateur effectue un paiement en ligne, Amplitudes est amené à collecter ses
              données personnelles afin de pouvoir procéder à la transaction.
            </p>
            <p>
              Afin de s’assurer de la sécurité des transactions effectuées sur leurs sites, Amplitudes collabore
              avec le prestataire bancaire Paybox, spécialisé dans le
              paiement en ligne. Paybox est chargé de
              collecter et de traiter les données personnelles de l’utilisateur concernant les moyens de
              paiement.
            </p>
            <p>
              Nous tenons à préciser que toutes les phases de paiement sont cryptées et protégées grâce au
              protocole SSL couplé à de la monétique bancaire. Cela permet de garantir que les informations
              concernant la commande et le numéro de carte bancaire ne circulent pas librement sur internet. De
              plus, nous garantissons que le numéro de carte bancaire ne sera imprimé sur aucun papier, facture, ou
              tout autre document. Paybox ne conserve aucune donnée concernant la carte bancaire une fois la
              transaction terminée, et il en va de même pour Amplitudes. Ces mesures de sécurité permettent à
              Amplitudes de préserver les données personnelles et les coordonnées de carte bancaire des clients, et
              de s’assurer que personne ne puisse y avoir accès par quelque moyen que ce soit.
            </p>
            <p>
              Nous utilisons le système de protection 3D SECURE, cryptée avec trois niveaux de vérification, et qui
              respecte les normes « PCI-DSS » (Payment Card Industry Data Security Standard).
            </p>
            <p>
              Si vous souhaitez avoir plus d’informations sur Paybox, vous pouvez aller consulter leur Politique de
              protection des données personnelles disponible sur leur site.
            </p>
            <p>
              Nous vous rappelons que si vous constatez une opération frauduleuse sur votre compte, vous devez
              impérativement le signaler dans les brefs délais à votre banque, ou à votre émetteur de carte
              bancaire.
            </p>
            <p />

            <h3><strong>2.2 Utilisation des données : </strong></h3>

            <p>
              Les données personnelles permettent avant tout d’accéder aux services du site et de les utiliser.
              Elles sont également nécessaires pour :
            </p>
            <ul>
              <li>traiter les demandes d’informations,</li>
              <li>étudier la fréquentation du site,</li>
              <li>
                envoyer des messages publicitaires ciblés ou de prospection commerciale, sous réserve d’un accord
                préalable de l’utilisateur,
              </li>
              <li>transmettre la Newsletter aux utilisateurs qui y sont abonnés,</li>
              <li>transmettre un catalogue,</li>
              <li>donner des informations sur les produits Amplitudes,</li>
              <li>mettre à disposition de l’utilisateur un outil de communication en ligne,</li>
              <li>informer des événements organisés par Amplitudes,</li>
              <li>
                mettre en place des sondages auxquels les utilisateurs sont libres de participer s’ils le
                souhaitent,
              </li>
              <li>permettre de suivre toutes les actualités du site,</li>
              <li>faire un recrutement (dans la partie « recrutement »),</li>
              <li>
                gérer les opérations commerciales (les commandes, les livraisons, les factures, la comptabilité,
                le suivi de la relation client, les réclamations et autres),
              </li>
              <li>proposer au client les offres des partenaires et/ou d’Amplitudes,</li>
              <li>
                réaliser des études et sondages, ainsi que des actions de fidélisation, de prospection et de
                promotion,
              </li>
              <li>personnaliser le site en fonction des préférences et besoins constatées ou déclarées,</li>
              <li>
                mettre en place une communication personnalisée avec les clients, notamment pour les informations
                envoyées par courrier électronique,
              </li>
              <li>gérer toutes les opérations concernant la prospection,</li>
              <li>effectuer des opérations de sollicitation commerciale,</li>
              <li>élaborer des statistiques commerciales et des analyses,</li>
              <li>gérer les demandes d’exercice des droits désignés ci-après,</li>
              <li>gérer les impayés et les contentieux,</li>
              <li>
                administrer les commentaires sur le site et/ou les pages éditées par Amplitudes sur les réseaux
                sociaux,
              </li>
              <li>protéger les utilisateurs et Amplitudes contre la fraude.</li>
            </ul>
            <p />

            <h3><strong>2.3 Conservation des données : </strong></h3>
            <p>
              Amplitudes peut conserver les données personnelles d’un utilisateur pendant dix ans à partir du
              dernier contact, c’est à dire à compter du dernier voyage effectué avec Amplitudes, ou de sa dernière
              utilisation du site ou du support de communication électronique.
            </p>
            <p>
              Les statistiques de mesure d'audience et les données de fréquentation brutes du site ne sont
              conservées que treize mois.
            </p>
            <p>
              Les données personnelles collectées dans l’espace recrutement (<a
                href="https://taleez.com/careers/amplitudes?Itemid=205"
                target="_blank"
                class="link-cgv"
              >https://taleez.com/careers/amplitudes?Itemid=205</a>)
              sont conservées 24 mois à partir de la dernière visite du candidat.
            </p>
          </div>

          <div style="text-align: justify">
            <h2>3. cookies</h2>

            <p>
              Les cookies ne permettent pas d’identifier de manière nominative un utilisateur. En revanche, ils
              permettent à Amplitudes d’avoir des informations concernant la navigation de l’utilisateur sur le site
              (pages consultées, date et heure de la consultation, et autres). Ils permettent également de connaître
              le nombre de contenus publicitaires affichés sur les différents types de site et application, et à
              être informé sur l’ouverture et la lecture des communications électroniques.
            </p>
            <p>
              Amplitudes a la possibilité d’insérer un cookie ou une balise web sur l’ordinateur de l’utilisateur
              lors de sa visite sur le site ou lorsqu’il sélectionne un élément envoyé par Amplitudes. Les cookies
              qu’Amplitudes émet à partir du site permettent de :
            </p>
            <ul>
              <li>mémoriser les choix et informations d’identification,</li>
              <li>
                élaborer des statistiques concernant la fréquentation et l'utilisation des divers éléments du site
                (rubriques consultées, navigation à travers les différents éléments), permettant d'améliorer la
                pertinence et l'ergonomie des services proposés,
              </li>
              <li>mettre en place une navigation et des services adaptés et ciblés,</li>
              <li>faire le décompte des clics sur un élément d'un service en ligne.</li>
            </ul>
            <p>
              Ceci peut varier en fonction des choix de paramétrage que vous avez mis en place sur votre terminal,
              et que vous êtes libres de modifier à tout moment.
            </p>
            <p />

            <p>
              Il arrive qu’Amplitudes achète des espaces publicitaires sur des sites, plateformes en ligne et
              applications afin de faire la promotion de ses produits. Ces espaces sont susceptibles de contenir des
              cookies. Excepté si vos choix de paramétrage de votre terminal ne le permettent pas, le cookie peut
              être enregistré dans votre terminal afin de :
            </p>
            <ul>
              <li>
                comptabiliser le nombre d'affichages et d'activations de nos contenus publicitaires diffusés sur
                des sites, applications ou réseaux sociaux,
              </li>
              <li>
                identifier les contenus publicitaires et les sites, applications ou réseaux sociaux où ils
                apparaissent,
              </li>
              <li>connaître le nombre d'utilisateurs ayant cliqué sur chaque contenu,</li>
              <li>
                adresser des publicités à l’utilisateur lors de sa navigation sur des sites tiers ou réseaux
                sociaux,
              </li>
              <li>élaborer des statistiques.</li>
            </ul>
            <p />

            <p><strong><em>Liste des usages de cookies faits sur le site d’Amplitudes</em></strong></p>
            <p />

            <ul>
              <li><strong>Cookies dits « fonctionnels »</strong></li>
            </ul>
            <p>
              Ces cookies sont nécessaires à certaines fonctionnalités du site comme la sauvegarde des préférences
              ou l’augmentation de la sécurité lors du passage sur l’espace sécurisé.
            </p>
            <p />
            <ul>
              <li><strong>Cookies dits « analytiques »</strong></li>
            </ul>
            <p>
              Ces cookies servent à élaborer des statistiques sur l'utilisation du site, dans le but d’améliorer la
              qualité de service. Cela permet par exemple de connaître les pages les plus consultées, ou encore les
              pages qui rencontrent certains problèmes et qui nécessitent l’intervention d’un ingénieur.
            </p>
            <p />
            <ul>
              <li><strong>Cookies dits « publicitaires »</strong></li>
            </ul>
            <p>
              Ces cookies permettent à Amplitudes de proposer des publicités plus pertinentes et en rapport avec
              les produits consultés et qui ont suscité le plus d’intérêt. Ils peuvent également servir à évaluer
              l’efficacité de nos campagnes de publicité en ligne.
            </p>
            <p />
            <ul>
              <li><strong>Cookies dits « externes »</strong></li>
            </ul>
            <p>
              Il s’agit des cookies installés sur votre terminal par d’autres sites. En effet, Amplitudes
              recommande parfois aux utilisateurs de se rendre sur des sites externes pour avoir certaines
              informations ou accéder à certains services. Il est possible de se renseigner sur les cookies utilisés
              par ces sites et sur leur utilisation en consultant leur politique de confidentialité et de protection
              des données.
            </p>
            <p>
              Vous pouvez à tout moment vous opposer à l’enregistrement de cookies en configurant les paramètres de
              votre navigateur :
            </p>
            <p />

            <ul>
              <li><strong>Google Chrome</strong></li>
            </ul>
            <p>
              Dans le menu <em>Paramètres</em>, sélectionnez <em>Afficher les paramètres
                avancés</em>.<br>Cliquez sur le bouton <em>Paramètres de contenu</em> dans la section <em>Confidentialité</em>.<br>Vous
              pouvez alors supprimer les cookies stockés et spécifier le comportement que vous souhaitez adopter
              vis-à-vis des cookies.
            </p>
            <p align="center" />
            <ul>
              <li><strong>Mozilla Firefox</strong></li>
            </ul>
            <p>
              Dans le menu <em>Outils</em>, sélectionnez <em>Options</em>.<br>Sélectionnez l'onglet <em>Vie
                privée</em>.<br>Puis choisissez <em>Utiliser les paramètres personnalisés pour l'historique</em>. <br>Vous
              pouvez alors spécifier le comportement que vous souhaitez adopter vis-à-vis des cookies.
            </p>
            <p />
            <ul>
              <li><strong>Internet Explorer</strong><strong /></li>
            </ul>
            <p>
              Dans le menu <em>Outils</em>, sélectionnez <em>Options internet</em>.<br>Cliquez sur
              l'onglet <em>Confidentialité</em>.<br>Vous pouvez alors gérer le niveau de blocage des cookies : <em>Bloquer
                tous les cookies</em>, <em>Haute</em>, <em>Moyenne</em> (niveau par défaut), <em>Faible</em>,
              et <em>Accepter tous les cookies</em>.
            </p>
            <p />
            <ul>
              <li><strong>Navigateur Safari</strong></li>
            </ul>
            <p>
              Dans le menu déroulant, sélectionnez l'option <em>Préférences</em>.<br>Ouvrez l'onglet <em>Sécurité</em>.<br>Vous
              pouvez alors spécifier le comportement que vous souhaitez adopter vis-à-vis des cookies.
            </p>
            <p>
              Rappelons ici que si vous décidez de ne pas autoriser les cookies sur votre terminal (ordinateur,
              tablette, mobile et autres), vous ne pourrez pas bénéficier de toutes les fonctionnalités du site.
            </p>
          </div>

          <div style="text-align: justify">
            <h2>4. partage et divulgation des données</h2>

            <p>
              Amplitudes et les sociétés qui lui sont associées sont les seules destinataires des données
              personnelles collectées. Toutefois, dans certains cas, Amplitudes peut être amené à transmettre des
              données personnelles à des prestataires de services (compagnies aériennes, hôtels, location de
              véhicules et autres) pour pouvoir réaliser certaines tâches.
            </p>
            <p>Amplitudes ne transmet les données personnelles à un tiers que lorsque :</p>
            <ul>
              <li>
                Amplitudes a préalablement reçu l’accord de la personne concernée pour le partage de ses données
                personnelles,
              </li>
              <li>
                Amplitudes doit transmettre les données personnelles à ses distributeurs, prestataires et
                prestataires techniques, pour fournir le service demandé (Newsletter ou autres),
              </li>
              <li>
                Amplitudes reçoit la requête d’une autorité judiciaire, ou de toute autorité administrative
                habilitée par la loi, sollicitant la transmission de ces informations conformément aux dispositions
                législatives en vigueur.
              </li>
            </ul>
            <p />
            <p>
              Tous nos partenaires qui sont amenés à avoir accès à vos données personnelles les traitent pour notre
              compte et conformément à nos instructions. Ils sont tenus de respecter la présente Politique de
              confidentialité et protection de la vie privée.
            </p>
            <p>
              Lorsque l’un de nos partenaires ne se situe pas dans l’Union Européenne, ou qu’il ne dispose pas
              d’une règlementation conforme à la Règlementation sur les données personnelles (<a
                href="https://www.cnil.fr/fr/la-protection-des-donnees-dans-le-monde"
                target="_blank"
                class="link-cgv"
              >https://www.cnil.fr/fr/la-protection-des-donnees-dans-le-monde</a>), Amplitudes met
              en place avec ce partenaire une relation contractuelle selon un dispositif approprié.
            </p>
            <p>
              Lesdits partenaires seront engagés par un contrat, qui intègrera les clauses contractuelles types
              (telles que publiées par la Commission Européenne) et garantira notamment un haut niveau de
              confidentialité et de protection des données personnelles. Tous les sous-traitants et prestataires
              sont tenus de mettre en place toutes les mesures techniques nécessaires pour garder les données
              personnelles en sécurité, et de respecter les conditions de protection exigées par la Règlementation
              sur les données personnelles.
            </p>
          </div>

          <div style="text-align: justify">
            <h2>5. données transmises par l'internaute sans sollicitation de chanel</h2>

            <p>
              Amplitudes peut conserver les données personnelles d’un utilisateur pendant dix ans à partir du
              dernier contact, c’est à dire à compter du dernier voyage effectué avec Amplitudes, ou de sa dernière
              utilisation du site ou du support de communication électronique.
            </p>
            <p>
              Les statistiques de mesure d'audience et les données de fréquentation brutes du site ne sont
              conservées que treize mois.
            </p>
            <p>
              Les données personnelles collectées dans l’espace recrutement (<a
                href="https://taleez.com/careers/amplitudes?Itemid=205"
                target="_blank"
                class="link-cgv"
              >https://taleez.com/careers/amplitudes?Itemid=205</a>)
              sont conservées 24 mois à partir de la dernière visite du candidat.
            </p>
          </div>

          <div style="text-align: justify">
            <h2>6. mesures de sécurité</h2>

            <p>
              Amplitudes fait ses meilleurs efforts afin de protéger les données personnelles contre les dommages,
              pertes, détournements, intrusions, divulgations, altérations ou destructions.<strong />
            </p>
            <p>
              Les systèmes informatiques d’Amplitudes font l’objet d’une constante protection physique et
              logicielle. Amplitudes a mis en place sur le site des procédures de sauvegarde physique et
              électronique des données collectées, conformément à la législation française en vigueur concernant la
              protection des données personnelles.
            </p>
            <p>
              Les salariés d’Amplitudes qui, de par leur fonction, peuvent avoir accès aux données personnelles,
              sont tenus à la plus grande confidentialité.
            </p>
            <p>
              Toutefois, Amplitudes ne peut prévoir, ni maîtriser tous les risques liés à internet. Nous tenons
              donc à rappeler que malgré la vigilance dont Amplitudes fait preuve, il existe des risques de pertes
              ponctuelles de données ou d’atteinte à la confidentialité des données transitant sur internet. Les
              informations proposées sur le site peuvent être interrompues en cas de force majeure ou indépendants
              de la volonté d’Amplitudes, ou de faits ne relevant pas de la responsabilité d’Amplitudes.
            </p>
          </div>

          <div style="text-align: justify">
            <h2>7. droits des personnes sur les données collectées</h2>

            <h3><strong>7.1 Droit des utilisateurs concernant la collecte des données :</strong></h3>
            <div>
              <strong style="font-family: Arial, Helvetica, sans-serif;">
                <h4 style="font-size: 14px;"><strong>Droit d'accès, de modification, de rectification et de
                  suppression</strong></h4>
              </strong>
            </div>
            <p>
              L’utilisateur dispose d’un droit général d’accès, de modification, de rectification et de suppression
              des données le concernant, conformément à la Règlementation sur les données personnelles.
              L’utilisateur peut donc :
            </p>
            <ul>
              <li>s’opposer au traitement de ses données s’il a un motif légitime,</li>
              <li>accéder librement à l’ensemble de ses données,</li>
              <li>rectifier, mettre à jour et supprimer ses données déclaratives, s’il a un motif légitime,</li>
              <li>demander la portabilité de ses données à partir du 25 mai 2018,</li>
              <li>demander une limitation du traitement de ses données.</li>
            </ul>
            <div>
              <strong style="font-family: Arial, Helvetica, sans-serif;">
                <h4 style="font-size: 14px;"><strong>Application de ces droits</strong></h4>
              </strong>
            </div>
            <p>
              Vous pouvez faire valoir ces droits en adressant une demande à notre service relations clientèle
              :
            </p>
            <ul>
              <li>
                <strong>par courrier</strong> : AMPLITUDES - Service Relations Clientèle, 20 rue du Rempart Saint
                Etienne, 31 000 Toulouse
              </li>
              <li>
                <strong>par e-mail</strong> : <a
                  href="mailto:contact@ampltides.com"
                  class="link-cgv"
                >contact@ampltides.com</a>
              </li>
              <li>
                <strong>en remplissant le formulaire </strong>: <a
                  href="/voyage-sur-mesure/contact-amplitudes-createur-de-voyages.html?Itemid=220"
                  target="_blank"
                  class="link-cgv"
                >https://www.amplitudes.com/voyage-sur-mesure/contact-amplitudes-createur-de-voyages.html?Itemid=220</a>
              </li>
              <li>
                <strong>par téléphone</strong> : en appelant au 05 67 31 70 00, du lundi au vendredi, de 10h à13h
                et de 14h à 19h.
              </li>
            </ul>
            <p>
              Afin que nous puissions répondre à votre demande, vous devez vous identifier en indiquant votre nom,
              prénom, e-mail et éventuellement votre adresse postale.
            </p>
            <p>
              Vous disposez également d'un droit d'accès, de modification et de suppression de vos données
              personnelles collectées dans l’espace recrutement du site d’Amplitudes. Vous pouvez nous faire
              parvenir votre demande
            </p>
            <ul>
              <li>
                <strong>par courrier</strong> : Service des Ressources Humaines, 20 rue du Rempart Saint Etienne,
                31 000 Toulouse
              </li>
              <li>
                <strong>par email</strong> : <a
                  href="mailto:elodie@amplitudes.com"
                  class="link-cgv"
                >elodie@amplitudes.com</a>
              </li>
            </ul>
            <p>
              Nous vous répondrons dans un délai d’un mois maximum à compter de la date de réception de votre
              demande.
            </p>
            <p />

            <h3><strong>7.2 Désabonnement de la newsletter :</strong></h3>
            <p>
              Amplitudes offre la possibilité aux utilisateurs de s’inscrire à la Newsletter (ou Lettre
              d’information) afin de se tenir informé sur les services et les produits proposés par Amplitudes.
            </p>
            <p>
              Il est également possible pour les utilisateurs qui ont souscrits à la Newsletter de se désabonner
              s’ils le souhaitent. Pour cela ils doivent :
            </p>
            <ul>
              <li>soit cliquer sur le lien de désinscription situé en bas de chaque Newsletter,</li>
              <li>
                soit envoyer un courrier à : AMPLITUDES - Service Relations Clientèle, 20 rue du Rempart
                Saint Etienne, 31 000 Toulouse,
              </li>
              <li>
                soit envoyer un courrier par e-mail à l’adresse : <a
                  href="mailto:contact@ampltides.com"
                  class="link-cgv"
                >contact@ampltides.com</a>
                ,
              </li>
              <li>
                soit remplir le formulaire <a
                  href="/voyage-sur-mesure/contact-amplitudes-createur-de-voyages.html?Itemid=220"
                  target="_blank"
                  class="link-cgv"
                >https://www.amplitudes.com/voyage-sur-mesure/contact-amplitudes-createur-de-voyages.html?Itemid=220</a>
                ,
              </li>
              <li>soit en appelant le 05 67 31 70 00 (du lundi au vendredi, de 10h à13h et de 14h à 19h).</li>
            </ul>
            <p>Votre demande sera prise en compte par Amplitudes dans les meilleurs délais.</p>
          </div>

          <div style="text-align: justify">
            <h2>8. usage des données en cas de changement de contrôle de la société</h2>

            <p>
              Dans le cas d’un changement de contrôle de la société, d’une acquisition, d’une procédure collective
              ou d’une vente des actifs de la société, les données personnelles collectées par Amplitudes sont alors
              susceptibles d’être transférés à des tiers.
            </p>
          </div>

          <div style="text-align: justify">
            <h2>9. politique de données personnelles relative aux mineurs</h2>

            <p>
              Le site d'Amplitudes, ainsi que les services qui y sont proposés, ne sont pas destinés aux mineurs.
              Cependant, l'accès au site n'est pas strictement réservé aux adultes car il ne contient pas d'éléments
              interdits aux mineurs. Nous rappelons que les mineurs ne sont pas autorisés à effectuer une quelconque
              réservation sur le site d'Amplitudes.
            </p>
            <p>
              Les formulaires et questionnaires du site e sont pas destinés à recueillir des informations sur les
              mineurs. Toutefois, si des informations concernant un mineur venaient à être recueillies sur le site,
              le représentant légal du mineur pourra contacter le Service des relations clientèles d'Amplitudes afin
              de rectifier, modifier ou supprimer ces informations.
            </p>
          </div>

          <div style="text-align: justify">
            <h2>10. mise à jour de la politique de données personnelles</h2>

            <p>
              Amplitudes se réserve le droit de modifier à tout moment et sans préavis la présente Politique de
              confidentialité et protection de la vie privée. Si Amplitudes souhaite utiliser vos données
              personnelles d'une manière différente de celle stipulée dans la Politique en vigueur au moment de la
              collecte, ces modifications seront alors publiées dans une nouvelle version.
            </p>
            <p>
              De ce fait, nous recommandons à l'utilisateur de consulter régulièrement la Politique de
              confidentialité et protection de la vie privée.
            </p>
          </div>

          <div style="text-align: justify">
            <h2>11. questions/contact</h2>

            <p>
              Pour toute demande d’information ou commentaire concernant la présente Politique de confidentialité
              et protection de la vie privée, vous pouvez vous adresser au service relations clientèle d’Amplitudes
              :
            </p>
            <ul>
              <li>
                <strong>par courrier</strong> : AMPLITUDES - Service Relations Clientèle, 20 rue du Rempart Saint
                Etienne, 31 000 Toulouse
              </li>
              <li><strong>par e-mail</strong> : contact@ampltides.com</li>
              <li>
                <strong>en remplissant le formulaire</strong> : <a
                  href="/voyage-sur-mesure/contact-amplitudes-createur-de-voyages.html?Itemid=220"
                  target="_blank"
                  class="link-cgv"
                >https://www.amplitudes.com/voyage-sur-mesure/contact-amplitudes-createur-de-voyages.html?Itemid=220</a>
              </li>
              <li>
                <strong>par téléphone</strong> : 05 67 31 70 00 (du lundi au vendredi, de 10h à 13h et de 14h à
                19h).
              </li>
            </ul>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Privacy',
  data: () => ({
    dialog: false
  })
}
</script>

<style scoped>
  .headline {
    color: white;
  }
</style>
